export const TIPO_RELATORIO_CSV_GRV = 'csv-placas-chassi'
export const TIPO_RELATORIO_IMPORTACAO_SECUNDARIA = 'importacao-secundaria'

export const FUNCOES_TIPOS_RELATORIO = {
  [TIPO_RELATORIO_CSV_GRV]: {
    fn: 'getDadosImportacaoCsvGrvs',
    messageEmpty: 'Não foi feita importação por GRV para este leilão!'
  },
  [TIPO_RELATORIO_IMPORTACAO_SECUNDARIA]: {
    fn: 'getDadosImportacaoSecundaria',
    messageEmpty: 'Não foi feita importação secundária para este leilão!'
  }
}

export const ARRAY_TIPOS_RELATORIO_PREPARACAO_LEILAO = [
  TIPO_RELATORIO_CSV_GRV,
  TIPO_RELATORIO_IMPORTACAO_SECUNDARIA
]



// WEBPACK FOOTER //
// ./src/domain/leiloes/helpers/tipos-relatorios-preparacao.js